module.exports = __webpack_public_path__ + "static/what-is-hodling-d7ae1f5d0f144a1cb0cd06be7e7c89aa.svg";